import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import { IKeyDisplayValuePair, Language } from '@common';
import { DtoSelfServiceFormData } from '../../../../core';
import { MarkdownPipe } from '../../../../shared';

@Component({
  selector: 'app-language-step',
  imports: [
    CommonModule,
    FormsModule,
    MarkdownPipe,
    MatButtonModule,
    MatFormFieldModule,
    MatOptionModule,
    MatSelectModule,
    MatStepperModule,
    ReactiveFormsModule
  ],
  templateUrl: './language-step.component.html',
  styleUrl: '../self-service-form.step.scss'
})
export class LanguageStepComponent {
  //#region Component Inputs --------------------------------------------------
  @Input({ required: true }) stepForm!: UntypedFormGroup;
  @Input({ required: true }) formData!: DtoSelfServiceFormData;
  @Input({ required: true }) languageSelectItems!: Array<IKeyDisplayValuePair<Language>>;
  //#endregion
}
